import { i18n } from '@lingui/core';
import { NumberInput } from '@mantine/core';
import { useContext } from 'react';
import PanePaper from '../../../../Molecules/PanePaper';
import { ProfileContext } from '../../../../Service/Context/ProfileContext';

const DocumentFristenSettings = () => {
  const { profile, patchProfile } = useContext(ProfileContext);
  const { offerValidUntil, invoiceValidUntil } = profile ?? {};

  return (
    <PanePaper title="document.deadlines">
      <NumberInput
        hideControls
        onBlur={(e) => patchProfile({ offerValidUntil: Number(e.currentTarget.value) })}
        label={i18n._('applicationUser.validUntil')}
        defaultValue={offerValidUntil}
        min={1}
        mb="sm"
        onKeyPress={(event) => {
          if (!/[0-9,\.]/.test(event.key)) {
            event.preventDefault();
          }
        }}
      />
      <NumberInput
        hideControls
        onBlur={(e) => patchProfile({ invoiceValidUntil: Number(e.currentTarget.value) })}
        label={i18n._('applicationUser.invoiceValidUntil')}
        defaultValue={invoiceValidUntil ?? undefined}
        min={1}
        onKeyPress={(event) => {
          if (!/[0-9,\.]/.test(event.key)) {
            event.preventDefault();
          }
        }}
      />
    </PanePaper>
  );
};

export default DocumentFristenSettings;
